// extracted by mini-css-extract-plugin
module.exports = {"customers":"OurCustomers_customers__yeNy7","container":"OurCustomers_container__0GNBA","img":"OurCustomers_img__N0fbo"};